import ackBelongsToEmployee from 'utils/ackBelongsToEmployee';

export const SIGNATURE_STATUS_COLOR = {
  pending: 'warning',
  viewed: 'info',
  signed: 'success',
  declined: 'error',
  expired: 'default',
};

export function documentLabel(message) {
  const fileName = message.attachments?.[0]?.name;
  if (fileName && message.title) return `${message.title} - ${fileName}`;
  return fileName || message.title || message.text || '';
}

export function signatureDate(message, employee) {
  const confirmedAt = (message.acknowledges || []).find(ack =>
    ackBelongsToEmployee(ack, employee),
  )?.confirmedAt;
  if (confirmedAt) return new Date(confirmedAt * 1000).toISOString();
  return message.createdAt || null;
}

export function isSignatureOpenable(message) {
  return message.displayStatus !== 'declined' && message.displayStatus !== 'expired';
}

export function signatureRowActions(message) {
  if (message.displayStatus !== 'viewed') return { decline: false, dismiss: false };
  return {
    decline: Boolean(message.digitalSignature),
    dismiss: Boolean(message.canDismiss),
  };
}

/**
 * Keep a just-signed document visible before the list request catches up.
 * Prepend it only on the first page, and only until some response has included it.
 * Later pages replace a row the server already returned; they do not insert others.
 */
export function mergeSignatureRows(status, messages, signedNow, page = 0, seenIds) {
  const signed = signedNow instanceof Map ? signedNow : new Map(signedNow || []);
  const seen = seenIds instanceof Set ? seenIds : new Set(seenIds || []);
  if (status === 'signed') {
    const overlaid = messages.map(item => signed.get(String(item._id)) || item);
    if (page !== 0) return overlaid;
    const ids = new Set(messages.map(item => String(item._id)));
    const extras = [...signed.values()].filter(item => {
      const id = String(item._id);
      return !ids.has(id) && !seen.has(id);
    });
    return [...extras, ...overlaid];
  }
  if (status === 'pending') {
    return messages.filter(item => !signed.has(String(item._id)));
  }
  return messages.map(item => signed.get(String(item._id)) || item);
}
